<template>
  <!-- <WeaponLvl />
  <LvlWeaponePicker /> -->
  <WeaponLvl />
  <LvlWeaponePicker v-if="!$isMobile()" />
  <MobileLvlWeapon v-else-if="$isMobile()" />
  <ExtraOptionPicker />
  <PlatformPicker />
</template>

<script setup>
import WeaponLvl from "../pickers/WeaponLvl.vue";
import PlatformPicker from "../../commonpickers/PlatformPicker.vue";
import LvlWeaponePicker from "../pickers/LvlWeaponePicker.vue";
import ExtraOptionPicker from "../pickers/ExtraOptionPicker.vue";
import MobileLvlWeapon from "../pickers/mobile/MobileLvlWeapon.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const firstWeapon = gameStore.getGamePack.pack_extra_options[0];
  const weapon = {
    category: "",
    weapon: firstWeapon.title,
    price: firstWeapon.price,
    catPrice: 0,
    timing: firstWeapon.timing,
    id: firstWeapon.id,
    category_id: null,
    type: firstWeapon.type,
    class: firstWeapon.description,
  };
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentLevel: 1,
    desiredLevel: 48,
  });
  checkoutStore.setCamoWeapon([weapon]);
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};

handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
